<template>
<div class="chapter">
<div class="inner_page">
<div id="a11_chart">
<a id="page_xxv">
<p class="chart">List of Charts</p>
<p class="chart1"><i>(at end of volume)</i></p>
<p class="chart1">(Times, as in the text, are G.M.T.)</p>
</a><p class="chart2"><a id="page_xxv"></a><span href="#/29_themaps#mapf1" title="Link target outside of Sample">1. North Sea, including opening movements of the Battle of Jutland. 2-15. The Battle of Jutland:</span></p>
<p class="chart2"><span href="#/29_themaps#mapf2" title="Link target outside of Sample">2. The situation at 2.45 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf3" title="Link target outside of Sample">3.     „     „     „     3.15 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf4" title="Link target outside of Sample">4.     „     „     „     4.10 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf5" title="Link target outside of Sample">5.     „     „     „     4.50 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf6" title="Link target outside of Sample">6.     „     „     „     5.30 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf7" title="Link target outside of Sample">7.     „     „     „     6.00 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf8" title="Link target outside of Sample">8.     „     „     „     6.30 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf9" title="Link target outside of Sample">9.     „     „     „     7.00 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf10" title="Link target outside of Sample">10.   „     „     „     7.25 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf11" title="Link target outside of Sample">11.   „     „     „     8.05 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf12" title="Link target outside of Sample">12.   „     „     „     9.00 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf13" title="Link target outside of Sample">13.   „     „     „     10.00 p.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf14" title="Link target outside of Sample">14.   Movements from 10.00 p.m. to 12.15 a.m</span></p>
<p class="chart2"><span href="#/29_themaps#mapf15" title="Link target outside of Sample">15.       „     „    12.15 a.m. to 6.00 a.m.</span></p>
<p class="chart2"><span href="#/29_themaps#mapf16" title="Link target outside of Sample">16.   North Sea Operations on 19 August 1916</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_chart.vue?64f6ae8d